// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2ghwm","loaderOuter":"PageOverlayLoader_loaderOuter__tyK3A"};